import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/workforce/sites/$siteId` — dal 01-11-2026 la scheda della sede sta in `/organization/sites/$siteId`.
 * L'indirizzo vecchio resta come rinvio, coi suoi parametri.
 */
export const Route = createFileRoute('/_app/workforce/sites/$siteId')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/organization/sites/$siteId', params: { siteId: params.siteId }, search: search as never, replace: true });
  },
});
